<template>
  <div class="dataCollect pc" v-empty="empty" :empty-text="emptyText">
    <div class="collect-header">
      <span class="header-left" @click="goHome">
        <span class="logo"></span>
        <span class="text">{{ $t('975ff67ee1') }}</span>
      </span>
      <div class="header-right">
        <search :data="collectValue" :collect="true" />
      </div>
    </div>
    <div class="container" id="imgList" ref="cscroll" @scroll="handleScroll">
      <imgList :data="data" :collect="true" :content="collectValue" :type="2" :loadDistance="300" :recommend="true"
        v-if="show" :top="top" />
    </div>
    <!-- <detail v-show="showDetailInfo" :id="id" :type="2" ref="detail" :loadDistance="300" /> -->
    <preview v-show="showPreview" ref="preview" />
    <div class="backTop" @click="backTop" v-if="showBackTop"></div>
  </div>
</template>
<script>
import search from '@/components/pc/search';
import imgList from '@/components/pc/imgList';
// import detail from '@/components/pc/detail';
import preview from '@/components/pc/preview';
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';
import { throttle, uniqueArr, getCookie } from '@/common';
import { getList, getCollect, collect } from '@/api/apiList';
import { mapState } from 'vuex';
export default {
  data() {
    return {
      showDetailInfo: false,
      showPreview: false,
      showBackTop: false,
      empty: '',
      emptyText: $t('9a79b39a1a'),
      data: [],
      detailData: null,
      //详情页id
      id: 0,
      //收藏滚动加载id
      collectId: '',
      collectFish: '',
      //首页的搜索框内容
      value: '',
      //收藏的搜索框内容
      collectValue: '',
      show: true,
      isScroll: false,
      top: 0,
      type: 2,
      page: 20,
      handleScroll: () => {},
      selectGroup: '',
    };
  },
  provide() {
    return {
      group: () => this.selectGroup,
    };
  },
  components: {
    search,
    imgList,
    // detail,
    preview,
  },
  watch: {
    data(newValue, oldValue) {
      if (newValue.length == 0) {
        this.empty = 'data';
        this.emptyText = $t('4233a27bd6');
      }
    },
    mycollect(newValue, oldValue) {
      if (newValue) {
        let index = this.data.findIndex(d => d.id == newValue.id);
        if (index > -1) {
          this.data[index].collectStatus = newValue.action;
          console.log(this.data[index].title, this.data[index].collectStatus);
        }
      }
    },
  },
  computed: {
    ...mapState(['mycollect']),
  },
  beforeRouteEnter(to, from, next) {
    if (from.path.includes('/dataDetail')) {
      next(vm => {
        vm.$nextTick(() => {
          vm.$refs.cscroll.scrollTop = vm.top;
          vm.getCollectData();
        });
      });
    } else {
      next(vm => {
        vm.$Talog({
          id: 'iFinD_news_tssj_tupian.jinrushoucang',
        });
        vm.page = 20;
        vm.collectFish = false;
        vm.collectId = '';
        vm.data = [];
        vm.collectValue = '';
        vm.show = false;
        vm.showDetailInfo = false;
        vm.$nextTick(() => {
          vm.show = true;
          vm.getCollectData();
        });
      });
    }
  },
  methods: {
    scroll(e) {
      const { scrollTop, clientHeight, scrollHeight } = e.target;
      console.log(scrollHeight - scrollTop - clientHeight);
      if (scrollHeight - scrollTop - clientHeight < 500) {
        this.getCollectData();
      }
    },
    scroll2(e) {
      const { scrollTop, clientHeight, scrollHeight } = e.target;
      let top = scrollTop;
      this.top = top > 0 ? top : this.top;
      this.isScroll = top > 0;
      this.showBackTop = top > 100;
    },
    goHome() {
      this.$router.push('/dataImage');
    },
    changePreview(val) {
      if (window.viewer) {
        window.viewer.destroy();
      }
      let _this = this;
      let rage = (window.innerHeight - 128) / window.innerHeight;
      const viewer = new Viewer(document.querySelector('.d-container'), {
        className: 'img_viewer',
        title: false,
        button: false,
        navbar: false,
        toolbar: false,
        initialCoverage: parseFloat(rage).toFixed(2),
        url(image) {
          if (image) {
            let url = location.protocol + image.getAttribute('src');
            console.log(url);
            return url;
          } else {
            return '';
          }
        },
        hide() {
          _this.showPreview = false;
        },
        viewed() {
          _this.$refs.preview.zoom = parseFloat(
            window.viewer.imageData.ratio
          ).toFixed(2);
          _this.$refs.preview.oldzoom = parseFloat(
            window.viewer.imageData.ratio
          ).toFixed(2);
          let img = document.querySelector('.viewer-canvas img');
          img.style.marginTop = '32px';
        },
        // move(e) {
        //   const { x, y } = e.detail;
        //   let w = window.innerWidth;
        //   let h = window.innerHeight;
        //   if (x < 0 || y < 0 || x > w || y > h) {
        //     viewer.reset();
        //   }
        // },
        zoomed(e) {
          _this.$Bus.$emit('zoom', e.detail.ratio);
          viewer.image.style.marginTop = '33px';
        },
      });
      window.viewer = viewer;
      viewer.show();
      this.showPreview = val;
    },
    backTop() {
      this.$refs.cscroll.scrollTop = 0;
    },
    downImg(item) {
      this.$Talog({
        id: 'iFinD_news_tssj_tupian.xiazai',
      });
      setTimeout(() => {
        this.$Talog({
          id: 'iFinD_appStore_tssj_pc_download',
          img_id: item.id,
        });
      }, 500);
      let thumbnailUrl = item.thumbnailUrl.split('.');
      const type = thumbnailUrl[thumbnailUrl.length - 1];
      if (getCookie('jgbsessid')) {
        let url = location.protocol + item.url;
        let href = `ifind://!command=down&filename=${item.title}.${type}&valuectrl=1&url=${url}`;
        location.href = href;
      } else {
        let img = new Image();
        img.setAttribute('crossOrigin', 'Anonymous');
        img.onload = function () {
          let canvas = document.createElement('canvas');
          let context = canvas.getContext('2d');
          canvas.width = img.width;
          canvas.height = img.height;
          context.drawImage(img, 0, 0, img.width, img.height);
          canvas.toBlob(blob => {
            let thumbnailUrl = item.thumbnailUrl.split('.');
            const type = thumbnailUrl[thumbnailUrl.length - 1];
            const link = document.createElement('a')
            link.download = `${item.title}.${type}`;
            link.href = URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.click();
            URL.revokeObjectURL(link.href);
            document.body.removeChild(link);
          });
        };
        img.src = item.thumbnailUrl + '?v=' + Date.now();
      }
    },
    async doCollect() {
      let i = this.data.findIndex(d => d.id == this.id);
      let collectStatus = Number(!this.data[i].collectStatus);
      let res = await collect({
        id: +this.data[i].id,
        action: collectStatus,
      }).catch(error => {
        this.empty = 'error';
        this.emptyText = $t('866b795eae');
      });
      if (res && res.code === 1) {
        this.data[i].collectStatus = collectStatus;
        if (this.data[i].collectStatus) {
          this.$message.success($t('f62827f0c4'));
        } else {
          this.data[i].collectNum =
            this.data[i].collectNum - 1 < 0 ? 0 : this.data[i].collectNum - 1;
          this.$message.success($t('cb0f88686e'));
          console.log(this.data[i].collectNum);
          // this.data.splice(i, 1);
        }
      } else {
        this.error = true;
        this.emptyText = $t('866b795eae');
      }
    },
    async getCollectData() {
      if (!this.collectFish) {
        let res = await getCollect({
          id: this.collectId,
          pageSize: this.page,
          content: this.collectValue,
        }).catch(error => {
          this.empty = 'error';
          this.emptyText = $t('866b795eae');
        });
        if (res && res.code === 1) {
          this.page = 10;
          let { data } = res;
          if (data && data.length > 0) {
            if (data.length == 0) {
              this.collectFish = true;
              return;
            }
            this.empty = '';
            this.data = uniqueArr(this.data.concat(data));
            //更新滚动所需要的参数
            this.collectId = data[data.length - 1].id;
          }
        } else {
          this.empty = 'error';
          this.emptyText = $t('866b795eae');
        }
      }
    },
    renderView(isInit = false) {
      if (isInit) {
        this.collectFish = false;
        this.collectId = '';
      }
      this.getCollectData();
    },
  },
  created() {
    this.handleScroll = throttle(this.scroll, 1000);
    document.body.style.minWidth = '1366px';
  },
  mounted() {
    this.$Bus.$on('shoucang-collect', () => {
      this.doCollect();
    });
    this.$Bus.$on('collectSearch', val => {
      this.$Talog({
        id: 'iFinD_news_tssj.sousuo',
      });
      this.page = 20;
      this.data = [];
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
        this.collectValue = val;
        this.renderView(true);
      });
    });
    this.$Bus.$on('collect-downImg', item => {
      this.downImg(item);
    });
    const scrollview = this.$refs['cscroll'];
    // 移除监听
    scrollview.addEventListener('scroll', this.scroll2, true);
  },
  beforeDestroy() {
    // 获取指定元素
    const scrollview = this.$refs['cscroll'];
    // 移除监听
    scrollview.removeEventListener('scroll', this.scroll2, true);
  },
};
</script>
<style lang="less" scoped>
.dataCollect {
  padding-top: 64px;
  height: 100%;
}
.collect-header {
  width: 100%;
  height: 64px;
  background: #ffffff;
  position: absolute;
  top: 0;
  border-bottom: 1px solid #ececf7;
  z-index: 999;
  .header-left {
    width: 83px;
    position: relative;
    left: 32px;
    cursor: pointer;
    .text {
      font-family: MicrosoftYaHei-Bold;
      font-size: 18px;
      color: #272841;
      letter-spacing: 0;
      font-weight: 700;
      line-height: 64px;
      display: inline-block;
    }
    .logo {
      width: 16px;
      height: 16px;
      background: url(~@/assets/images/back.svg) no-repeat 100% 100%;
      display: inline-block;
      margin-right: 5px;
      position: relative;
      top: 2px;
    }
    &:hover .text {
      color: #1b63d9;
    }
    &:hover .logo {
      background: url(~@/assets/images/back_hover.svg) no-repeat 100% 100%;
    }
  }
  .header-right {
    position: absolute;
    right: 34px;
    height: 36px;
    top: 16px;
    display: flex;
    align-items: center;
  }
}
#imgList {
  height: 100%;
  overflow-y: auto;
  padding: 24px 42px;
}
.backTop {
  width: 48px;
  height: 48px;
  background: url(~@/assets/images/backTop.svg) no-repeat 100% 100%;
  position: fixed;
  right: 32px;
  bottom: 32px;
  cursor: pointer;
  &:hover {
    background: url(~@/assets/images/backTop_hover.svg) no-repeat 100% 100%;
  }
}
.hideList {
  height: calc(100vh - 64px);
  overflow: hidden;
}
</style>
